<template>
  <vue3videoPlay
    ref="videoElement"
    v-bind="options"
    :poster="cover"
    :src="videosrc"    
    @loadstart="onLoadstart"
    @play="onPlay"
    @pause="onPause"
    @playing="onPlaying"
    @seeking="onSeeking"
    @seeked="onSeeked"
    @waiting="onWaiting"
    @durationchange="onDurationchange"
    @progress="onProgress"
    @canplay="onCanplay"
    @timeupdate="onTimeupdate"
    @ended="onEnded"
    @error="onError"
    @stalled="onStalled"
    @canplaythrough="onCanPlayThrough"
    :key="vue3VideoPlayKey"
  />
</template>
<script >
import { ref, toRefs, reactive , watch , onMounted } from 'vue';
import vue3videoPlay from 'vue3-video-play';
import 'vue3-video-play/dist/style.css';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Video',
  components: {
    vue3videoPlay
  },
  props: {
    videosrc: {
      type: String,
      required:true
    },
    videotype: {
      type: String,
      required:true
    },
    videocover: {
      type: String,
      required:true
    },
    lastcurrenttime: {
      type: String ,
      required:true
    },
    speedrate: {
      type: Number ,
      required:true
    },
    volume: {
      type: Number,
      required:true
    },
    autoplay: {
      type: Boolean ,
      required:true
    },
    muted: {
      type: Boolean ,
      required:true
    },
    loop: {
      type: Boolean ,
      required:true
    }
  },
  emits: [
    'onPlayCallback', 
    'onPauseCallback', 
    'onTimeupdateCallback', 
    'onEndCallback', 
    'onErrorCallback', 
    'onScreenChangeCallback', 
  ],
  setup(props,{emit}) {
    const { 
      lastcurrenttime,
      speedrate,
      volume,
    } = toRefs(props);

    const videoElement = ref(null);
    const vue3VideoPlayKey = ref(0);
    const lastCurrentTime = ref(0);
    const videoTag = ref(null);
    const isPlayingState = ref(false);

    // 自動回放離開前的播放進度 / 自訂義播放位置
    function roadLastCurrentTime(){
      if (props.lastcurrenttime > 0){
        lastCurrentTime.value = props.lastcurrenttime;
      }
      else {
        lastCurrentTime.value = 0;
      }
    }
    roadLastCurrentTime();


    const cover = ref(props.videocover);
    const options = reactive({
      width: '100%', // 播放器寬度
      height: '100%', // 播放器高度
      // height: "480.94px", // 播放器高度
      color: '#409eff', // 主顏色
      title: '', // 視頻名稱
      src: props.videosrc,
      type: props.videotype, 
      muted: props.muted, // 靜音
      webFullScreen: false,
      speedRate: ['0.5', '0.75', '1.0', '1.25', '1.5', '2.0', '4.0'], // 播放倍數
      autoPlay: props.autoplay, // 自動播放
      currentTime: lastCurrentTime.value, // 從 n 秒開始播放
      volume: props.volume/100, // 默認音量大小
      control: false, //是否顯示控制
      playsinline: true,
      loop: props.loop, // 循環播放
    });


    const onLoadstart = (event) => {
      // console.log("影片讀取中");
    };
    const onPlay = (event) => {
      emit('onPlayCallback', event);
      isPlayingState.value = true;
      // console.log('播放');
    };
    const onPause = (event) => {
      emit('onPauseCallback', event);
      isPlayingState.value = false;
      // console.log('暫停');
    };
    const onPlaying = (event) => {
      // console.log('影片播放中');
    };
    const onSeeking = (event) => {
      // console.log('快進中...');
    };
    const onSeeked = (event) => {
      // console.log('快進');
    };
    const onWaiting = (event) => {
      // console.log('緩衝中...');
    };
    const onDurationchange = (event) => {
      // console.log('onDurationchange');
    };
    const onProgress = (event) => {
      // console.log('onProgress', event);
    };
    const onCanplay = (event) => {
      // console.log('可以播放影片');
    };
    const onTimeupdate = (event) => {
      emit('onTimeupdateCallback', event.srcElement);
    };
    const onEnded = () => {
      // console.log("影片結束");
      emit('onEndCallback');
    };
    const onError = (event) => {
      // console.log('onError', event);
    };
    const onStalled = (event) => {
      // console.log('網路速度有變化');
    };
    const onCanPlayThrough = (event) => {
      // console.log('onCanPlayThrough');
      if (videoTag.value != null){
        if (videoTag.value.muted){
          videoTag.value.muted = false;
        }
        const videoPromise = document.querySelector('video').play();

        if (videoPromise != null) {
          videoPromise.then(() => {
            document.querySelector('video').play();
          });
        }
        //playMedia();
      }
    };

    watch(lastcurrenttime, (newValue) => {
      if (videoTag.value != null && newValue != null){
        videoTag.value.currentTime = newValue;
      }
    });

    watch(speedrate, (newValue) => {
      if (videoTag.value != null && newValue != null){
        videoTag.value.playbackRate = newValue;
      }
    });

    watch(volume, (newValue) => {
      if (videoTag.value != null && newValue != null){
        videoTag.value.volume = newValue/100;
      }
    });
    function checkIsFullScreen(){
      let isFull = document.fullscreen || document.mozfullscreen || document.webkitIsFullScreen;

      return isFull == null ? false : isFull;
    }
    function toggleScreen(){
      if(checkIsFullScreen()){
        emit('onScreenChangeCallback', true);
      }
      else {
        emit('onScreenChangeCallback', false);
      }
    }
    function launchFullscreen(element) {
      if(element.requestFullscreen) {
        element.requestFullscreen();
      } else if(element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if(element.msRequestFullscreen){
        element.msRequestFullscreen();
      } else if(element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else if (element.webkitSupportsFullscreen) {
        element.webkitEnterFullscreen();
      }
    }
    function exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
    function play(){
      const videoPromise = document.querySelector('video').play();

      if (videoPromise != null) {
        videoPromise.then(() => {
          document.querySelector('video').play();
        });
      }
    }
    function pause(){
      const videoPromise = document.querySelector('video').pause();

      if (videoPromise != null) {
        videoPromise.then(() => {
          document.querySelector('video').pause();
        });
      }
    }
    function isPlaying(){
      if (videoTag.value != null){
        videoTag.value.isPlaying();
      }
    }
    function enterFullScreen(){
      launchFullscreen(videoTag.value);
    }
    function exitFullScreen(){
      exitFullscreen(videoTag.value);
    }
    function setVolume(value){
      if (videoTag.value != null){
        videoTag.value.volume = value/100;
      }
    }
    function setPlaybackRate(value){
      if (videoTag.value != null){
        videoTag.value.playbackRate = value;
      }
    }
    function setPlaybackRate2(){
      if (videoTag.value != null){
        videoTag.value.playbackRate = props.speedrate;
      }
      clearInterval(timer);

    }
    function changeQuality(value){
      if (videoTag.value != null){
        videoTag.value.pause();
        options.src = value;
        videoTag.value.crossOrigin = 'anonymous';
        videoTag.value.load();
        vue3VideoPlayKey.value++;        
      }
    }

    let timer = null;

    onMounted(async () => {
      if (videoElement.value != null){
        videoElement.value.play(); // iOS 一定要先執行這段
      }
      videoTag.value = document.getElementById('dPlayerVideoMain');
      if(videoTag.value){
        videoTag.value.controls = false;
      }
      videoTag.value.addEventListener('fullscreenchange', toggleScreen);

      if (videoTag.value && videoTag.value.playbackRate && props.speedrate){
        timer = setInterval(setPlaybackRate2, 500);
      }
    });

    return {
      // vue3videoPlay
      cover,
      options,
      videoElement,
      onLoadstart,
      onPlay,
      onPause,
      onPlaying,
      onSeeking,
      onSeeked,
      onWaiting,
      onDurationchange,
      onProgress,
      onCanplay,
      onTimeupdate,
      onEnded,
      onError,
      onStalled,
      onCanPlayThrough,
      vue3VideoPlayKey,

      play,
      pause,
      isPlaying,
      enterFullScreen,
      exitFullScreen,
      setVolume,
      setPlaybackRate,
      changeQuality,


    };
  },
};
</script>
<style >
  /*iOS 手機裝置有異常，故隱藏 loading 動畫*/
  .d-loading,
  .d-pointer {
    display: none !important;
  }
 
  /*指定第四個隱藏*/
  .d-player-contextmenu-body,
  .d-player-contextmenu-body li:nth-child(4){
    display: none !important;
  }

  /*第三方預設播放按鈕*/
  .d-play-btn{
    display: none !important;
  }
  .d-player-wrap{
    background-color: white !important;
  }

  video::-webkit-media-controls-enclosure,
  video::-webkit-media-fullscreen-button,
  video::-webkit-media-mute-button,
  video::-webkit-media-play-button,
  video::-webkit-media-volume-slider,
  video::-webkit-media-controls-timeline,
  video::-webkit-media-controls-current-time-display,
  video::-webkit-media-controls-time-remaining-display
  {
    
  }

  video{
    background-color: black !important;
  }
  

  
</style>